import { createSelector } from "@reduxjs/toolkit";

// ========== Base selector ==========
export const selectVaccinationState = (state) => state.vaccinations;

// ========== Data selector ==========
const selectVaccinationDataRaw = (state) => state.vaccinations?.data;

export const selectVaccinationData = createSelector(
  [selectVaccinationDataRaw],
  (data) => Array.isArray(data) ? data : []
);

// ========== Loading selector ==========
export const selectVaccinationLoading = (state) => 
  Boolean(state.vaccinations?.loading);

// ========== Error selector ==========
export const selectVaccinationError = (state) => 
  state.vaccinations?.error ?? null;

// ========== Has Fetched selector (✅ AJOUTÉ) ==========
export const selectVaccinationHasFetched = (state) => 
  Boolean(state.vaccinations?.hasFetched);

// ========== Derived selectors ==========
export const selectVaccinationCount = createSelector(
  [selectVaccinationData],
  (data) => data.length
);

export const selectVaccinationByYear = createSelector(
  [selectVaccinationData],
  (data) => {
    const byYear = {};
    data.forEach((vac) => {
      const year = vac.date ? new Date(vac.date).getFullYear() : "Unknown";
      if (!byYear[year]) byYear[year] = [];
      byYear[year].push(vac);
    });
    return byYear;
  }
);